import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { Card } from '../../../components/ui/Card';
import type { PeriodOption } from '@repo/shared-dashboard';

interface GroupReportsWidgetProps {
  period?: PeriodOption;
}

export function GroupReportsWidget({ period = 'month' }: GroupReportsWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <Card className="p-5 flex flex-col justify-between h-full">
      <div className="flex items-center justify-between border-b border-border pb-3 mb-4">
        <h3 className="text-sm font-semibold text-text-primary">Group Reports</h3>
      </div>
      <DataView query={query} isEmpty={() => false}>
        {(data) => {
          const depositDone = data?.groupReports?.depositDonePercent ?? 0;
          const psoDone = data?.groupReports?.psoDonePercent ?? 0;
          const agreementDone = data?.groupReports?.agreementDonePercent ?? 0;
          const groupsCount = data?.groupsCount ?? 0;

          return (
            <div>
              <div className="space-y-5">
                <div>
                  <div className="flex justify-between text-sm mb-1.5">
                    <span className="text-text-secondary">Deposit Done</span>
                    <span className="font-semibold text-text-primary tnum">{depositDone}%</span>
                  </div>
                  <div className="w-full bg-surface-2 h-2 rounded-full overflow-hidden">
                    <div
                      className="bg-accent-500 h-full rounded-full transition-all duration-500"
                      style={{ width: `${depositDone}%` }}
                    />
                  </div>
                </div>
                <div>
                  <div className="flex justify-between text-sm mb-1.5">
                    <span className="text-text-secondary">PSO Done</span>
                    <span className="font-semibold text-text-primary tnum">{psoDone}%</span>
                  </div>
                  <div className="w-full bg-surface-2 h-2 rounded-full overflow-hidden">
                    <div
                      className="bg-text-secondary h-full rounded-full transition-all duration-500"
                      style={{ width: `${psoDone}%` }}
                    />
                  </div>
                </div>
                <div>
                  <div className="flex justify-between text-sm mb-1.5">
                    <span className="text-text-secondary">Agreement Done</span>
                    <span className="font-semibold text-text-primary tnum">{agreementDone}%</span>
                  </div>
                  <div className="w-full bg-surface-2 h-2 rounded-full overflow-hidden">
                    <div
                      className="bg-success-bg h-full rounded-full transition-all duration-500"
                      style={{ width: `${agreementDone}%` }}
                    />
                  </div>
                </div>
              </div>
              <p className="text-xs text-text-muted mt-5 italic border-t border-border pt-3">
                For total number of {groupsCount} created groups
              </p>
            </div>
          );
        }}
      </DataView>
    </Card>
  );
}

